/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "tag": {
    "size_text": "text-al-category-md",
    "colors_text": "text-al-korall-700",
    "variant_text": "uppercase"
  },
  "empty_size_default": "mt-3 gap-6 col-span-4 text-al-body-lg",
  "empty_colors_default": "",
  "empty_variant_default": "flex flex-col",
  "headline_variant_default": "inline",
  "headline_colors_default": "bg-white",
  "headline_size_default": "text-al-headline-sm",
  "line_variant_default": "",
  "line_colors_default": "",
  "line_size_default": "md:mb-1",
  "button_variant_default": "",
  "button_colors_default": "",
  "button_size_default": "mx-auto w-fit mt-1 md:mt-3",
  "icon_variant_default": "cursor-pointer",
  "icon_colors_default": "text-al-gray-300 hover:text-al-gray-500",
  "icon_size_default": "",
  "article_caption_variant_default": "",
  "article_caption_colors_default": "",
  "article_caption_size_default": "pt-1.5 text-al-headline-xs md:text-al-headline-sm",
  "article_description_variant_default": "",
  "article_description_colors_default": "",
  "article_description_size_default": "pt-1.5 md:pt-2 text-al-body-sm md:text-al-body-md",
  "article_header_variant_default": "flex justify-between items-center",
  "article_header_colors_default": "",
  "article_header_size_default": "pt-3",
  "article_link_variant_default": "",
  "article_link_colors_default": "",
  "article_link_size_default": "",
  "article_image_variant_default": "",
  "article_image_colors_default": "",
  "article_image_size_default": "",
  "article_variant_default": "",
  "article_colors_default": "",
  "article_size_default": "",
  "variant_default": "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
  "colors_default": "",
  "size_default": "gap-6"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "SavedArticles");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;